import { SelectListFiltersSingleChoice } from "Explore/Components";
import { IconPack } from "Explore/Config/Icons";
import React from "react";
import styles from "./Departments.module.scss";

const Departments = ({
  departments,
  selectedDepartment,
  setSelectedDepartment,
  landscape,
}) => {
  return (
    <div
      className={`${styles["departments"]}  ${
        landscape ? "" : styles["shadow"]
      }`}
    >
      <div className={styles["department-title"]}>
        {IconPack.department}
        <p>Departments</p>
      </div>

      <SelectListFiltersSingleChoice
        placeholder={"Department"}
        options={departments}
        filters={selectedDepartment}
        setFilters={setSelectedDepartment}
        entity={"departments"}
        style={{ width: "100%", height: "30px" }}
      />
      {departments.map((item, index) => {
        return (
          <div
            key={index}
            className={`${styles["department-card"]} ${
              selectedDepartment.departments &&
              selectedDepartment.departments.indexOf(item.value) !== -1
                ? styles["department-card-selected"]
                : ""
            }`}
            onClick={() => {
              setSelectedDepartment({
                departments: [item.value],
              });
            }}
          >
            {item.department}
          </div>
        );
      })}
    </div>
  );
};

export default Departments;
